import LegalPage from '@/pages/legal/legal-page'

export default function Terms() {
  return <LegalPage documentKey="terms" path="/terms" />
}
